export class OTA_Source {
    public isoCountry: string;
    public isoCurrency: string;
}
